import React from 'react';
import '../styles/FilesDragAndDrop.css';
import {read} from 'xlsx';
import FileFormatter from "./FileFormatters/FileFormatter";
import FileComparer from "./FileComparers/FileComparer";
import MemberAuditer from "./FileComparers/MemberAuditer";
//import TrueRXClaimChecker from "./FileComparers/TrueRXClaimChecker";
//import MissingClaimFinder from "./FileComparers/MissingClaimFinder";
import TransparentFormatter from "./FileFormatters/TransparentFormatter";
import H2BFormatter from "./FileFormatters/H2BFormatter";
import ImagineMDFormatter from "./FileFormatters/ImagineMDFormatter";
import EHIMFormatter from "./FileFormatters/EHIMFormatter";
import MedefyFormatter from "./FileFormatters/MedefyFormatter";
import MedefyAccumFormatter from "./FileFormatters/MedefyAccumFormatter";
import EHIMAccumFormatter from "./FileFormatters/EHIMAccumFormatter";
import UnitedConciergeFormatter from "./FileFormatters/UnitedConciergeFormatter";
import NurseryNavigatorsFormatter from "./FileFormatters/NurseryNavigatorsFormatter";
import EvolutionsFormatter from "./FileFormatters/EvolutionsFormatter";
import HealthbusFormatter from "./FileFormatters/HealthbusFormatter";
import AMPSFormatter from "./FileFormatters/AMPSFormatter";
import DisclosedRXFormatter from "./FileFormatters/DisclosedRXFormatter";
import FairscriptsFormatter from "./FileFormatters/FairscriptsFormatter";
import CoreToolFileFormatter from "./FileFormatters/CoreToolFileFormatter";
//import FedIDBenefitCodeMatcher from "./FileComparers/FedIDBenefitCodeMatcher";


function FilesDragAndDrop() {
    //State is used here to manipulate what is displayed by the UI while dragging a file and what renders in response to the drop
    const [dragging, setDragging] = React.useState(false);
    const [excelCensus , setCensus] = React.useState({});
    const [excelCompare , setCompare] = React.useState({});
    const [excelAudit , setAudit] = React.useState({});
    //const [excelClaimsList , setFind] = React.useState({});
    //const [excelClaimsText , setClaimsText] = React.useState({});
    const [excelTransparentElig , setTransparentElig] = React.useState({});
    const [excelH2BElig , setH2BElig] = React.useState({});
    const [excelIMGElig , setIMGElig] = React.useState({});
    const [excelEHIMElig , setEHIMElig] = React.useState({});
    //const [excelFedIDBenefits , setFedIDBenefits] = React.useState({});
    const [excelMedefyElig , setMedefyElig] = React.useState({});
    const [excelMedefyAccum , setMedefyAccum] = React.useState({});
    const [excelEHIMAccum , setEHIMAccum] = React.useState({});
    const [excelUnitedConcierge , setUnitedConcierge] = React.useState({});
    const [excelCNN , setCNN] = React.useState({});
    const [excelEvolutions , setEvolutions] = React.useState({});
    const [excelHealthbus , setHealhbus] = React.useState({});
    const [excelAMPS , setAMPS] = React.useState({});
    const [excelDRX , setDRX] = React.useState({});
    const [excelFS , setFS] = React.useState({});
    const [excelCoreToolCensus , setCoreToolCensus] = React.useState({});

    //Values used for detecting hover state and applying effects as needed
    const drop = React.useRef<any>(null);
    const drag = React.useRef(null);

    let text : string = "";
    //we call use effect to allow responses from external factors-in this case the file being dragged
    React.useEffect(() => {

        //Stops default when dragging file
        const handleDragOver = (e: any) => {
            e.preventDefault();
            e.stopPropagation();
        };

        //When dropping a file this updates the state for UI rendering, checks for file data, and sends if found
        //Should add file type validation here, will do later
        const handleDrop = async (e: any) => {
            e.preventDefault();
            e.stopPropagation();

            setDragging(false);

                const rawFiles = await e.dataTransfer.files[0];
                const files = await rawFiles.arrayBuffer();
                const fileName = await rawFiles.name;
                //console.log(files);
                //console.log(e.dataTransfer.files[0]);

                if(await rawFiles.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    const wb: any = read(files, {sheetStubs: true});

                    //on grabbing a file from drag and drop trim the .xlsx from the name and store it
                    wb.FileName = fileName.substring(0, fileName.length - 5).toUpperCase();
                    //console.log(files, "UPLOAD");
                    //use state to set the data variable and trigger a rerender so the formatter fires again with the new data. Split apart to reduce unnecessary rendering
                    if(wb.Sheets.Census){
                        setCensus(wb);
                    }
                    else if(wb.Sheets.OldSheet && wb.Sheets.NewSheet){
                        setCompare(wb);
                    }
                    else if (wb.Sheets.OldMembers && wb.Sheets.NewMembers){
                        setAudit(wb);
                    }
                    else if (wb.Sheets.Transparent){
                        setTransparentElig(wb);
                    }
                    else if (wb.Sheets.H2B){
                        setH2BElig(wb);
                    }
                    else if (wb.Sheets.IMG){
                        setIMGElig(wb);
                    }
                    else if (wb.Sheets.EHIM){
                        setEHIMElig(wb);
                    }
                    else if (wb.Sheets.EHIMAccum){
                        setEHIMAccum(wb);
                    }
                    else if (wb.Sheets.MedefyAccum && wb.Sheets.Medefy){
                        setMedefyAccum(wb);
                    }
                    else if (wb.Sheets.Medefy){
                        setMedefyElig(wb);
                    }
                    else if (wb.Sheets.United){
                        setUnitedConcierge(wb);
                    }
                    else if (wb.Sheets.CNN){
                        setCNN(wb);
                    }
                    else if (wb.Sheets.Evolutions){
                        setEvolutions(wb);
                    }
                    else if (wb.Sheets.Healthbus){
                        setHealhbus(wb);
                    }
                    else if (wb.Sheets.AMPS){
                        setAMPS(wb);
                    }
                    else if (wb.Sheets.DRX){
                        setDRX(wb);
                    }
                    else if (wb.Sheets.FS){
                        setFS(wb);
                    }
                    else if (wb.Sheets.CoreToolCensus){
                        setCoreToolCensus(wb);
                    }
                    // else if (wb.Sheets.FID && wb.Sheets.PlanCodes){
                    //     setFedIDBenefits(wb);
                    // }
                    // else if (wb.Sheets.TrueRXClaimsData && wb.Sheets.CASClaimsData){
                    //     setFind(wb);
                    // }
                    // else if (wb.Sheets.TRUERXCLAIMSTEXT && wb.Sheets.MissingClaimID){
                    //     setClaimsText(wb);
                    // }
                }
                else if (await rawFiles.type === "text/plain"){
                    const reader = new FileReader()
                    reader.onload = async (e) => {
                        if(e.target){
                            text += (e.target.result);
                            console.log(text);
                        }
                    }
                    reader.readAsText(rawFiles);
                }
        };

        //changes UI when dragging file over
        const handleDragEnter = (e: any) => {
            e.preventDefault();
            e.stopPropagation();

            setDragging(true);
        };

        //opposite of above, resets when dragging away from drop area
        const handleDragLeave = (e: any) => {
            e.preventDefault();
            e.stopPropagation();

            if (e.target === drag.current) {
                setDragging(false);
            }
        };

        //setting event listeners
        drop?.current?.addEventListener('dragover', handleDragOver);
        drop?.current?.addEventListener('drop', handleDrop);
        drop?.current?.addEventListener('dragenter', handleDragEnter);
        drop?.current?.addEventListener('dragleave', handleDragLeave);

        return () => {
            drop?.current?.removeEventListener('dragover', handleDragOver);
            drop?.current?.removeEventListener('drop', handleDrop);
            drop?.current?.removeEventListener('dragenter', handleDragEnter);
            // eslint-disable-next-line react-hooks/exhaustive-deps
            drop?.current?.removeEventListener('dragleave', handleDragLeave);
        };
    }, []);

    //return only has hover layout, default is below and displays conditionally based on state to avoid overlapping
    return (
        <div ref={drop}>
            {dragging && (
                <div ref={drag} className='FilesDragAndDrop__placeholder'>
                    Drop That File And Watch It Go!
                    <span
                        role='img'
                        aria-label='emoji'
                        className='area__icon'
                    >
                        &#128565;
                    </span>
                </div>
            )}
            {!dragging ? <DefaultArea/> : null}
            <FileFormatter excelData={excelCensus}></FileFormatter>
            <FileComparer excelData={excelCompare}></FileComparer>
            <MemberAuditer excelData={excelAudit}></MemberAuditer>
            <TransparentFormatter excelData={excelTransparentElig}></TransparentFormatter>
            <H2BFormatter excelData={excelH2BElig}></H2BFormatter>
            <ImagineMDFormatter excelData={excelIMGElig}></ImagineMDFormatter>
            <EHIMFormatter excelData={excelEHIMElig}></EHIMFormatter>
            <MedefyFormatter excelData={excelMedefyElig}></MedefyFormatter>
            <MedefyAccumFormatter excelData={excelMedefyAccum}></MedefyAccumFormatter>
            <EHIMAccumFormatter excelData={excelEHIMAccum}></EHIMAccumFormatter>
            <UnitedConciergeFormatter excelData={excelUnitedConcierge}></UnitedConciergeFormatter>
            <NurseryNavigatorsFormatter excelData={excelCNN}></NurseryNavigatorsFormatter>
            <EvolutionsFormatter excelData={excelEvolutions}></EvolutionsFormatter>
            <HealthbusFormatter excelData={excelHealthbus}></HealthbusFormatter>
            <AMPSFormatter excelData={excelAMPS}></AMPSFormatter>
            <DisclosedRXFormatter excelData={excelDRX}></DisclosedRXFormatter>
            <FairscriptsFormatter excelData={excelFS}></FairscriptsFormatter>
            <CoreToolFileFormatter excelData={excelCoreToolCensus}></CoreToolFileFormatter>
            {/*<FedIDBenefitCodeMatcher excelData={excelFedIDBenefits}></FedIDBenefitCodeMatcher>*/}
            {/*<TrueRXClaimChecker excelData={excelClaimsList}></TrueRXClaimChecker>*/}
            {/*<MissingClaimFinder excelData={excelClaimsText}></MissingClaimFinder>*/}
        </div>
    );
}

export default React.memo(FilesDragAndDrop);

//Regular no hover display
const DefaultArea = () => {
    return (
        <div id="defaultArea" className='FilesDragAndDrop__area'>
        Drag And Drop Census, Member Audit, or CORE Census Files
            <span
                role='img'
                aria-label='emoji'
                className='area__icon'
            >
                &#128526;
            </span>
        </div>

    )
}